/**
 * The map's colours in one place, so the contrast test can read them: node
 * fills and label fills by kind, and the page background they sit on.
 */
import type { NodeKind } from './layout.js';

export const PAGE_BACKGROUND = '#fafaf9';
export const FILL: Readonly<Record<NodeKind, string>> = { anchor: '#1c1917', funder: '#0f766e', member: '#78716c', excluded: '#d6d3d1' };
// A ghost's label stays readable: the dashed circle already marks it as set aside, and a faded label
// (#a8a29e measured 2.4:1 against the page) fell under the AA floor the specification sets for all text.
export const LABEL_FILL: Readonly<Record<NodeKind, string>> = { anchor: '#292524', funder: '#292524', member: '#292524', excluded: '#78716c' };
